import React from "react";
import { useLocation } from 'react-router-dom';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import layoutHOC from "HOC/layoutHOC";
import config from "constants/config";
import Header from "./header";
import Sidebar from "./sidebar";
import { Error as ErrorBoundary } from "../../../../components";
import CustomizationDocumentation from "../../screens/customization/documentation";
import { useSelector } from "react-redux";
import useWindowSize from "../../../../hooks/useWindowSize";
import "./index.scss";


const ThemeDocsLayout = () => {

    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const { windowHeight } = useWindowSize();
    const bannerHeight = useSelector(({nav}) => nav.bannerHeight);
    const url = params.get('section') || '/';

    return (
        <GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
            <ErrorBoundary>
              <>
                  <Header selectedItem={url} />
                  <div className="app-body" style={{ height: `calc(${windowHeight}px - ${bannerHeight}px - 3.5rem - 3rem)` }}>

                    <main className="main ml-0">
                          <div className="container">
                              <div className="docs-screen">

                                  <Sidebar selectedItem={url} />

                                  <div className="docs-content-wrapper">
                                      <CustomizationDocumentation selectedItem={url} />
                                  </div>
                              </div>
                          </div>
                      </main>

                  </div>
              </>
            </ErrorBoundary>
        </GoogleReCaptchaProvider>
    );

};

export default layoutHOC(ThemeDocsLayout);
